import React from "react";
import { Container, Grid, Typography, Box } from "@mui/material";
import Navbar from "../../Components/Navbar";
import Header from "../../Components/Header";
import Footer from "../../Components/Footer";
import MahendraChaudhary from "../../assets/MahendraChaudhary.avif";
import School from "../../assets/ShreeSchool.jpeg";
import PageTitle from "../../Components/PageTitle";

const DirectorMessage = () => {
  return (
    <>
      <Navbar />
      <PageTitle
        title="Message from the Director - Shree Mangalam School"
        description="Explore the vision and leadership of the Director of Shree Mangalam School. A commitment to academic excellence and holistic development for students aiming at RIMC, Sainik, and Military Schools."
        url="/director-message"
        keywords="director message, Shree Manglam director, school leadership, educational vision, RIMC sainik school coaching, military school guidance"
      />

      <Header image={School} alt={"Shree Mangalam School"} />
      <Container
        sx={{ mb: 5, mt: 5 }}
        // sx={{ padding: "2rem", maxWidth: "1200px", margin: "0 auto" }}
      >
        <Typography
          variant="h5"
          sx={{
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            fontSize: "30px",
            letterSpacing: 1,
            color: "#065A79",
            fontWeight: "bold",
          }}
          gutterBottom
        >
          Director Message
        </Typography>
        <Grid container spacing={3} mt={3}>
          {/* Image Section - 4 columns */}
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "1.5rem",
                backgroundColor: "#C49A4B",
                padding: "1rem",
                borderRadius: "8px",
                mt: { xs: 0, md: 9 },
              }}
            >
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "1fr",
                  gap: "1.5rem",
                }}
              >
                <img
                  src={MahendraChaudhary}
                  // src="https://gpsnkt.gudhaeducationhub.com/schoolerp/website_upload/2024/02/f2024105114p1.jpg"
                  alt="Director Mahendra Chaudhary"
                  style={{
                    width: "100%",
                    height: "auto",
                    borderRadius: "8px",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                  }}
                />
                <Typography
                  variant="body1"
                  sx={{
                    mt: -2,
                    fontWeight: "bold",
                    fontFamily: "Montserrat, sans-serif",
                    fontOpticalSizing: "auto",
                    fontStyle: "normal",
                    letterSpacing: 1,
                  }}
                >
                  Director:{" "}
                  <span
                    style={{
                      color: "#AD1C86",
                      fontWeight: "bold",
                      fontStyle: "italic",
                      fontSize: "1.1rem",
                    }}
                  >
                    Mr.Mahendra Chaudhary
                  </span>
                </Typography>
              </Box>
            </Box>
          </Grid>

          {/* Content Section - 8 columns */}
          <Grid item xs={12} md={8}>
            <Box
              sx={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}
            >
              <Typography
                variant="h5"
                sx={{
                  fontFamily: "Montserrat, sans-serif",
                  fontOpticalSizing: "auto",
                  fontStyle: "normal",
                  // fontSize: "25px",
                  letterSpacing: 1,
                  color: "#AD1C86",
                  fontWeight: "bold",
                }}
              >
                Dear Parents,
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  //  mt:1,
                  fontFamily: "Montserrat, sans-serif",
                  fontOpticalSizing: "auto",
                  fontStyle: "normal",
                  letterSpacing: 1,
                  lineHeight: "1.8rem",
                }}
              >
                I am excited to share some remarkable news that marks a
                significant milestone in our educational journey. It is with
                immense pleasure that I announce the opening of a new branch
                under the prestigious banner of Shree Mangalam School.
                This expansion is the result of a visionary initiative that
                demonstrates our unwavering commitment to advancing education
                and fostering a culture of academic excellence.
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  //  mt:1,
                  fontFamily: "Montserrat, sans-serif",
                  fontOpticalSizing: "auto",
                  fontStyle: "normal",
                  letterSpacing: 1,
                  lineHeight: "1.8rem",
                }}
              >
                The new branch of Shree Mangalam School is an extension of our mission to provide high-quality education and create an environment that promotes the holistic development of every student. We are dedicated to continuing our legacy of excellence, instilling the same values, principles, and passion for education in this new venture.
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  //  mt:1,
                  fontFamily: "Montserrat, sans-serif",
                  fontOpticalSizing: "auto",
                  fontStyle: "normal",
                  letterSpacing: 1,
                  lineHeight: "1.8rem",
                }}
              >
                The support of the Shree Mangalam School leadership has
                been vital in bringing this expansion to life, reflecting our
                shared vision to empower students and make a meaningful impact
                in the community. We believe education is a transformative
                force, and this new branch will enable us to reach even more
                students, enriching their lives and contributing positively to
                their future.
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  //  mt:1,
                  fontFamily: "Montserrat, sans-serif",
                  fontOpticalSizing: "auto",
                  fontStyle: "normal",
                  letterSpacing: 1,
                  lineHeight: "1.8rem",
                }}
              >
                As we embark on this exciting chapter, I would like to express
                my sincere gratitude to the entire team at Shree Mangalam
                School for their dedication and vision for educational
                excellence. To our school community, your continued support is
                invaluable, and we are eager to work together in making this new
                branch a success.
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  fontFamily: "Montserrat, sans-serif",
                  fontOpticalSizing: "auto",
                  fontStyle: "normal",
                  letterSpacing: 1,
                  lineHeight: "1.8rem",
                }}
              >
                At Shree Mangalam School, we remain committed to
                maintaining the highest standards of education and ensuring that
                every student is equipped to thrive in the challenges and
                opportunities of the future. Thank you for being an essential
                part of our growing family.
              </Typography>

              <Box sx={{ fontStyle: "italic" }}>
                <Typography
                  variant="body1"
                  sx={{
                    fontFamily: "Montserrat, sans-serif",
                    fontOpticalSizing: "auto",
                    fontStyle: "normal",
                    letterSpacing: 1,
                    lineHeight: "1.8rem",
                  }}
                >
                  With warm regards,
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontWeight: "bold",
                    letterSpacing: 1,
                    lineHeight: "1.8rem",
                    color: "#AD1C86",
                  }}
                >
                  Mr.Mahendra Chaudhary
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontFamily: "Montserrat, sans-serif",
                    fontOpticalSizing: "auto",
                    fontStyle: "normal",
                    letterSpacing: 1,
                    lineHeight: "1.8rem",
                  }}
                >
                  Director
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <Footer />
    </>
  );
};

export default DirectorMessage;
